

export default {
  lei: null,
  error: null,
  hasErrors: false,
  credentials: [],
  pagination: {
    currentPage: 0,
    from: 0,
    lastPage: 0,
    perPage: 0,
    to: 0,
    total: 0,
  },
  roles: [],
  loading: false,
}



// WEBPACK FOOTER //
// ./src/store/modules/credential/state.js